import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import Countdown from 'react-countdown-now';
import { v4 as uuid } from 'uuid';

import Registration from './Registration';
import ProgressIndicator from '../../../../Common/ProgressIndicator';
import ErrorIndicator from '../../../../Common/ErrorIndicator';
import RegistrationModal from './RegistrationModal';

import { USER, ORGANISER, GUEST, PRAESES, MEMBER } from '../../../../../Data/Constants';
//import { EventRegistrationUser } from '../../../../../Data/Classes';
import { AuthContext } from '../../../../../Data/AuthContext';
import Axios from 'axios';

function RegistrationSection(props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [regs, setRegs] = useState([]);
    const [registration, setRegistration] = useState({});
    const auth = useContext(AuthContext);

    const { event } = props;

    const hasUserReg = regs.findIndex(reg => reg.type === USER || reg.type === ORGANISER) !== -1;
    const canAcceptMoreGuests = regs.filter(reg => reg.type === GUEST).length < event.guestsPerUserLimit;
    const registrationEnded = new Date(event.registrationDeadline) < new Date();
    const registrationStarted = new Date(event.registrationStartDate) < new Date();
    const isMember = auth.roles && auth.roles.includes(MEMBER);
    const canRegister = (registrationStarted || isMember) && !registrationEnded 
        && ((event.onlyFreshmenCanRegister && auth.isFreshman) || !event.onlyFreshmenCanRegister || isMember);

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/events/${props.event.id}/registrations`).then(res => {
            setRegs(res);
            setIsLoading(false);
        }, err => {
            setError(true);
            setIsLoading(false);
        });
    }, [props]);

    function onNewRegClick(e, type) {
        setRegistration({
            id: 0,
            type: type,
            guestName: '',
            guestEmail: '',
            steinCaption: '',
            remark: '',
            post: PRAESES,
            eventId: event.id
        });
        setIsModalOpen(true);
    }

    function onRegistrationClick(reg) {
        setRegistration(reg);
        setIsModalOpen(true);
    }

    if (isLoading)
        return <ProgressIndicator />;
    if (error)
        return <ErrorIndicator text='A jelentkezések letöltése nem sikerült.' />;

    const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
        return completed ? null : <p><em>A jelentkezés {days}:{hours}:{minutes}:{seconds} múlva kezdődik.</em></p>
    };

    return (
        <Row>
            <Col>
                <h3>Jelentkezés{regs.length > 0 ? "eim" : null}</h3>
                {registrationEnded && <p><em>A jelentkezési határidő lejárt.</em></p>}
                {!registrationStarted && <Countdown date={new Date(event.registrationStartDate)} renderer={countdownRenderer} />}
                {(event.onlyFreshmenCanRegister && !auth.isFreshman && !isMember) && <p><em>Nyilvántartásunk szerint nem vagy gólya, így erre a rendezvényre nem tudsz jelentkezni.</em></p>}
                {!hasUserReg && canRegister && <Button color="primary" type="button" onClick={e => onNewRegClick(e, USER)}>
                    <FontAwesomeIcon icon={faUserPlus} /> Jelentkezés
            </Button>}
                <Row className="mb-3">
                    {regs.map(item => <Registration registration={item} key={uuid()} onClick={() => onRegistrationClick(item)} />)}
                    {hasUserReg && canAcceptMoreGuests && canRegister &&
                        <Button color="primary" type="button" className="col-lg-4 col-md-6 mx-auto py-5" onClick={e => onNewRegClick(e, GUEST)}>
                            <FontAwesomeIcon icon={faUserPlus} /> Vendég hozzáadása
                                </Button>}
                </Row>
            </Col>
            <RegistrationModal isOpen={isModalOpen} close={() => setIsModalOpen(false)} registration={registration} event={event} callback={props.callback} />
        </Row>
    );
}

export default RegistrationSection;